import Axios from '../config/Axios';

export function downloadReportLeituraPDF(oOptions = {}) {
    const {
      template = 'relatorio_leitura',
      cFileName = 'relatorio_leitura',
      content = '',
      meta = {},
    } = oOptions;
  
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('cStorageToken');
  
      const apiURL = `${process.env.REACT_APP_CONVERT_URL}/convertTemplate`;
  
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/pdf',
        'Content-Type': 'application/json',
      };
  
      const axiosConfig = {
        responseType: 'blob',
        headers,
        withCredentials: true, // mantém o mesmo comportamento do conversor
      };
  
      const payload = {
        template,
        content,
        meta,
      };
  
      Axios.post(apiURL, payload, axiosConfig)
        .then((oResponse) => {
          const fFile = new Blob([oResponse.data], { type: 'application/pdf' });
          const cFileURL = URL.createObjectURL(fFile);
  
          const elLink = document.createElement('a');
          elLink.href = cFileURL;
          elLink.setAttribute('download', `${cFileName}.pdf`);
          document.body.appendChild(elLink);
          elLink.click();
  
          setTimeout(() => URL.revokeObjectURL(cFileURL), 100);
          resolve();
        })
        .catch((oError) => {
          console.error('Erro no download do PDF (relatório leitura):', oError);
  
          // tenta ler mensagem JSON/texto do backend mesmo vindo como blob
          if (oError?.response?.data) {
            new Response(oError.response.data)
              .text()
              .then((cText) => reject(cText))
              .catch(() => reject(oError?.message));
          } else {
            reject(oError?.message);
          }
        });
    });
  }
  